import { createActionName } from "../../../utility"

export const reducerName = "plans"

export const PLAN = createActionName(reducerName, "PLAN")
export const PLANS = createActionName(reducerName, "PLANS")
